import { Component, ElementRef, EventEmitter, Input, OnInit, Output, Renderer2 } from '@angular/core';
import { MatLegacyTabChangeEvent as MatTabChangeEvent } from '@angular/material/legacy-tabs';
import { AdjustColorValues } from '../../../directives/adjust-color/adjust-color.directive';

export interface TabWithCount {
    id: number;
    type: string;
    name: string;
    color: string;
    count: number;
}

export interface TabWithCountChangeEvent extends MatTabChangeEvent {
    data: TabWithCount;
}

@Component({
    selector: 'app-tabs-with-count',
    templateUrl: './tabs-with-count.component.html',
})
export class TabsWithCountComponent implements OnInit {
    @Input() tabs: TabWithCount[];
    @Output() selectedTabChange: EventEmitter<TabWithCountChangeEvent> = new EventEmitter<TabWithCountChangeEvent>();

    currentIndex = 0;
    currentTab: TabWithCount;

    readonly adjustColorValues = AdjustColorValues;
    readonly defaultTabColor = '#000000';

    constructor(
        private _elementRef: ElementRef,
        private _renderer: Renderer2,
    ) {
    }

    ngOnInit() {
        this.currentTab = this.tabs[this.currentIndex];
    }

    changeActiveTab(event: MatTabChangeEvent){
        this.currentTab = this.tabs[this.currentIndex];

        const inkBar = this._elementRef.nativeElement.querySelector('.mat-ink-bar');
        this._renderer.setStyle(inkBar, 'background-color', this.currentTab.color);

        this.selectedTabChange.emit({ data: this.currentTab, ...event });
    }
}
